import { useEffect, useState } from 'react';
import axios from 'axios';
import { Search } from 'lucide-react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Checkbox } from '../ui/checkbox';
import { nomComplet } from './constantes';

const FILTRES = [['tous', 'Tous'], ['formateur', 'Formateurs'], ['tuteur', "Maîtres d'apprentissage"], ['entreprise', 'Entreprises'],
  ['stagiaire', 'Apprentis'], ['responsable_pedagogique', 'Resp. pédagogiques'], ['centre', 'Direction']];

export const AjoutAnnuaireDialog = ({ open, onClose, dejaIds, onAjouter }) => {
  const [liste, setListe] = useState([]);
  const [sel, setSel] = useState([]);
  const [filtre, setFiltre] = useState('tous');
  const [q, setQ] = useState('');
  useEffect(() => {
    if (!open) return;
    setSel([]);
    axios.get('/conseil-perfectionnement/annuaire').then(({ data }) => setListe(data)).catch(() => setListe([]));
  }, [open]);
  const visibles = liste.filter((p) => !dejaIds.includes(p.user_id) && (filtre === 'tous' || p.role === filtre)
    && `${p.nom} ${p.prenom} ${p.organisation}`.toLowerCase().includes(q.trim().toLowerCase()));
  const basculer = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const valider = () => { onAjouter(liste.filter((p) => sel.includes(p.user_id))); onClose(); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="cp-annuaire-dialog">
        <DialogHeader><DialogTitle>Ajouter depuis l'application</DialogTitle></DialogHeader>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher" className="pl-9" data-testid="cp-annuaire-recherche" />
        </div>
        <div className="flex gap-2 overflow-x-auto pb-1">
          {FILTRES.map(([k, l]) => (
            <button key={k} type="button" onClick={() => setFiltre(k)} data-testid={`cp-annuaire-filtre-${k}`}
              className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${filtre === k ? 'bg-[#0F172A] text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>{l}</button>
          ))}
        </div>
        <div className="max-h-[45vh] divide-y overflow-y-auto">
          {visibles.length === 0 && <p className="py-8 text-center text-sm text-slate-400" data-testid="cp-annuaire-vide">Personne à ajouter</p>}
          {visibles.map((p) => (
            <label key={p.user_id} className="flex cursor-pointer items-center gap-3 py-2.5" data-testid={`cp-annuaire-${p.user_id}`}>
              <Checkbox checked={sel.includes(p.user_id)} onCheckedChange={() => basculer(p.user_id)} />
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-[#0F172A]">{nomComplet(p)}</p>
                <p className="truncate text-xs text-slate-500">{p.qualite}{p.organisation ? ` – ${p.organisation}` : ''}</p>
              </div>
            </label>
          ))}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => setSel((s) => [...new Set([...s, ...visibles.map((p) => p.user_id)])])} data-testid="cp-annuaire-tout">Tout cocher</Button>
          <Button onClick={valider} disabled={!sel.length} className="bg-[#0F172A]" data-testid="cp-annuaire-ajouter">Ajouter ({sel.length})</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
